/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { SocialExportFragmentSourceDto } from "./SocialExportFragmentSourceDto";
import type { SocialExportMediaUrlSourceDto } from "./SocialExportMediaUrlSourceDto";
import type { SocialExportPublicJobWithResultDto } from "./SocialExportPublicJobWithResultDto";
import type { SocialExportUploadCancelledDataDto } from "./SocialExportUploadCancelledDataDto";
import type { SocialExportUploadCompletedDataDto } from "./SocialExportUploadCompletedDataDto";
import type { SocialExportUploadFailedDataDto } from "./SocialExportUploadFailedDataDto";
import type { SocialExportUploadInProgressDataDto } from "./SocialExportUploadInProgressDataDto";
import type { SocialExportUploadPlatformFeaturesDto } from "./SocialExportUploadPlatformFeaturesDto";
import type { SocialExportUploadScheduledDataDto } from "./SocialExportUploadScheduledDataDto";
import type { SocialExportUploadWaitingChildrenDataDto } from "./SocialExportUploadWaitingChildrenDataDto";
import type { SocialExportUploadWaitingDataDto } from "./SocialExportUploadWaitingDataDto";
import type { SocialExportVideoEditorEditSourceDto } from "./SocialExportVideoEditorEditSourceDto";

export const SocialExportUploadDtoPlatformEnum = {
    YOUTUBE: "YOUTUBE",
    TWITTER: "TWITTER",
    INSTAGRAM: "INSTAGRAM",
    DAILYMOTION: "DAILYMOTION",
    FACEBOOK: "FACEBOOK",
    DEMO: "DEMO",
    TIKTOK: "TIKTOK",
    RUDO: "RUDO"
} as const;

export type SocialExportUploadDtoPlatformEnumKey = (typeof SocialExportUploadDtoPlatformEnum)[keyof typeof SocialExportUploadDtoPlatformEnum];

export const SocialExportUploadDtoStatusEnum = {
    SCHEDULED: "SCHEDULED",
    WAITING: "WAITING",
    WAITING_CHILDREN: "WAITING_CHILDREN",
    IN_PROGRESS: "IN_PROGRESS",
    COMPLETED: "COMPLETED",
    FAILED: "FAILED",
    CANCELLED: "CANCELLED"
} as const;

export type SocialExportUploadDtoStatusEnumKey = (typeof SocialExportUploadDtoStatusEnum)[keyof typeof SocialExportUploadDtoStatusEnum];

export type SocialExportUploadDto = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    platform: SocialExportUploadDtoPlatformEnumKey;
    /**
     * @type string
    */
    clientId: string;
    /**
     * @description Platform profile id (e.g. channel id)
     * @type string
    */
    profileId?: string | null;
    /**
     * @type string
    */
    connectionId?: string | null;
    /**
     * @description Station the upload was created from, when known
     * @type string
    */
    stationId?: string | null;
    /**
     * @type string
    */
    createdBy?: string | null;
    /**
     * @type string
    */
    key: string;
    source: (SocialExportMediaUrlSourceDto | SocialExportFragmentSourceDto | SocialExportVideoEditorEditSourceDto);
    data: (SocialExportUploadScheduledDataDto | SocialExportUploadWaitingDataDto | SocialExportUploadWaitingChildrenDataDto | SocialExportUploadInProgressDataDto | SocialExportUploadCompletedDataDto | SocialExportUploadFailedDataDto | SocialExportUploadCancelledDataDto);
    /**
     * @type object
    */
    publishData: {
        [key: string]: any;
    };
    /**
     * @type string
    */
    createdAt: string;
    /**
     * @type string
    */
    status: SocialExportUploadDtoStatusEnumKey;
    /**
     * @type boolean
    */
    isPending: boolean;
    /**
     * @description True when the upload is waiting for source media to be generated before publishing can start
     * @type boolean
    */
    waitingForMedia: boolean;
    /**
     * @description BullMQ job snapshot including status and progress
     * @type object
    */
    job?: SocialExportPublicJobWithResultDto | null;
    /**
     * @description Platform-specific features (manage URL, public URL, deletability)
    */
    platformFeatures?: SocialExportUploadPlatformFeaturesDto;
};